import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback, useEffect, useRef } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import Accordion from '../Accordion';
import FormField from './FormField';
import { FORM_BUTTON_TYPES } from './formConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormWithAccordian = _ref => {
  var _customSubmitButtonWi;
  var id = _ref.id,
    accordians = _ref.accordians,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange,
    defaultValues = _ref.defaultValues,
    accordionIndex = _ref.accordionIndex,
    handleAccordionToggle = _ref.handleAccordionToggle,
    validationSchema = _ref.validationSchema,
    getFormState = _ref.getFormState,
    testid = _ref.testid,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'on' : _ref$autoComplete,
    _ref$fieldsetDisabled = _ref.fieldsetDisabled,
    fieldsetDisabled = _ref$fieldsetDisabled === void 0 ? false : _ref$fieldsetDisabled;
  var _useForm = useForm({
      mode: 'onBlur',
      defaultValues,
      resolver: validationSchema ? yupResolver(validationSchema) : undefined
    }),
    control = _useForm.control,
    handleSubmit = _useForm.handleSubmit,
    getValues = _useForm.getValues,
    errors = _useForm.formState.errors,
    setError = _useForm.setError,
    clearErrors = _useForm.clearErrors,
    setValue = _useForm.setValue,
    watch = _useForm.watch,
    trigger = _useForm.trigger;
  var watchValuesForFormWithAccordian = useWatch({
    control
  });
  var errorsReference = useRef({});
  var accordianFields = accordians.flatMap(accordian => accordian.elements.fields);
  var customSubmitButtonWithAccordian = accordianFields === null || accordianFields === void 0 ? void 0 : accordianFields.find(field => (field === null || field === void 0 ? void 0 : field.type) === FORM_BUTTON_TYPES.SUBMIT);
  var noSubmitActionWithAccordian = () => console.error('Form does not have a submit button with an action set');
  var errorFnForAccordians = errors => {
    var firstElementName = Object.keys(errors)[0];
    var errorAccordianIndex = accordians.findIndex(accordian => accordian.elements.fields.some(field => field.name === firstElementName));
    handleAccordionToggle(errorAccordianIndex);
    setTimeout(() => {
      var _firstErrorElement$sc;
      var firstErrorElement = document.querySelector("[data-fieldname=\"".concat(firstElementName, "\"]"));
      firstErrorElement === null || firstErrorElement === void 0 || (_firstErrorElement$sc = firstErrorElement.scrollIntoView) === null || _firstErrorElement$sc === void 0 || _firstErrorElement$sc.call(firstErrorElement, {
        behavior: 'smooth'
      });
    }, 50);
  };
  useEffect(() => {
    var subscription = watch(() => {
      if (onChange) {
        onChange(getValues());
      }
    });
    return () => subscription.unsubscribe();
  }, [watchValuesForFormWithAccordian]);
  useEffect(() => {
    return () => {
      getFormState === null || getFormState === void 0 || getFormState(getValues(), errorsReference.current);
    };
  }, [getFormState, getValues]);
  useEffect(() => {
    errorsReference.current = errors;
  }, [errors]);
  var handleAccordianTriggerValidation = useCallback(fieldsName => {
    trigger(fieldsName);
  }, [trigger]);
  var handleSetValueWithAccordian = useCallback((fieldName, value) => {
    setValue(fieldName, value);
  }, [setValue]);
  var handleSetErrorWithAccordian = useCallback((fieldName, error, config) => {
    setError(fieldName, error, config);
  }, [setError]);
  var handleClearErrorsWithAccordian = useCallback(fieldName => {
    clearErrors(fieldName);
  }, [clearErrors]);
  var accordianSubmitFn = (_customSubmitButtonWi = customSubmitButtonWithAccordian === null || customSubmitButtonWithAccordian === void 0 ? void 0 : customSubmitButtonWithAccordian.action) !== null && _customSubmitButtonWi !== void 0 ? _customSubmitButtonWi : noSubmitActionWithAccordian;
  function renderAccordianContent(_ref2) {
    var fields = _ref2.fields,
      formStyles = _ref2.formStyles,
      fieldsContainerStyles = _ref2.fieldsContainerStyles;
    return _jsx(Box, _objectSpread(_objectSpread({}, formStyles), {}, {
      children: _jsx("fieldset", {
        disabled: fieldsetDisabled,
        style: styleFieldsetWithAccordian(fieldsetDisabled),
        children: _jsx(Flex, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, defaultFieldsContainerStylesWithAccordian), fieldsContainerStyles)), {}, {
          children: fields.map(formField => {
            var _formField$id, _formField$props$isDi, _formField$props;
            return _jsx(FormField, {
              formField: formField,
              control: control,
              getValues: getValues,
              handleSetValue: handleSetValueWithAccordian,
              errors: errors,
              handleClearErrors: handleClearErrorsWithAccordian,
              handleSetError: handleSetErrorWithAccordian,
              handleTriggerValidation: handleAccordianTriggerValidation,
              onChangeAction: formField === null || formField === void 0 ? void 0 : formField.onChangeAction,
              btnProps: {
                onClick: formField.type === FORM_BUTTON_TYPES.BUTTON ? () => formField.action(trigger) : undefined,
                varient: 'primary',
                isDisabled: (_formField$props$isDi = (_formField$props = formField.props) === null || _formField$props === void 0 ? void 0 : _formField$props.isDisabled) !== null && _formField$props$isDi !== void 0 ? _formField$props$isDi : false,
                label: formField.label,
                size: 'full',
                type: formField.type
              }
            }, "".concat(formField.name, "-").concat((_formField$id = formField.id) !== null && _formField$id !== void 0 ? _formField$id : ''));
          })
        }))
      })
    }));
  }
  function renderAccordionItems() {
    var accordionItems = accordians.map(accordian => ({
      title: accordian.title,
      content: renderAccordianContent(accordian.elements),
      onToggleSection: accordian.onToggleSection
    }));
    return accordionItems;
  }
  return _jsx("form", {
    id: id,
    onSubmit: handleSubmit(accordianSubmitFn, errorFnForAccordians),
    "data-testid": testid,
    autoComplete: autoComplete,
    children: _jsx(Accordion, {
      allowMultiple: true,
      accordionItems: renderAccordionItems(),
      bgColor: 'baseWhite',
      accordionOverwriteStyles: _objectSpread(_objectSpread({}, accordionOverwriteStyles), {}, {
        container: _objectSpread(_objectSpread({}, accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.container), {}, {
          index: [accordionIndex]
        })
      })
    })
  });
};
var defaultFieldsContainerStylesWithAccordian = {
  direction: 'column',
  height: 'auto',
  justifyContent: 'flex-start',
  marginBottom: 'var(--chakra-space-lg)'
};
var defaultFieldsetStyleWithAccordian = {
  border: '0',
  padding: '0.01em 0 0 0',
  margin: '0',
  minWidth: '0'
};
var styleFieldsetWithAccordian = isDisabled => {
  return isDisabled ? _objectSpread(_objectSpread({}, {
    opacity: '0.4',
    pointerEvents: 'none'
  }), defaultFieldsetStyleWithAccordian) : defaultFieldsetStyleWithAccordian;
};
var accordionContainerStyle = {
  border: '1px solid var(--chakra-colors-lightGrey2)',
  borderTop: 0
};
var accordionItemButtonStyle = {
  sx: {
    div: {
      color: 'darkGrey2'
    }
  },
  _expanded: {
    borderBottom: '1px solid var(--chakra-colors-lightGrey3)'
  },
  pl: 'md',
  fontSize: '2xl',
  fontWeight: '600'
};
var accordionItemTextStyle = {
  fontWeight: 'semibold',
  fontSize: '2xl',
  borderTop: 0
};
var accordionItemPanelStyle = {
  padding: '0 var(--chakra-space-lg)'
};
var accordionItemStyle = {
  borderBottom: 0,
  borderTop: '1px solid var(--chakra-colors-lightGrey2)'
};
var accordionOverwriteStyles = {
  container: accordionContainerStyle,
  button: accordionItemButtonStyle,
  text: accordionItemTextStyle,
  panel: accordionItemPanelStyle,
  item: accordionItemStyle
};